import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/Layout.js";
import Image from '../components/Image';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@reach/tabs';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`En Gatsby tenemos `}<strong parentName="p">{`muchas`}</strong>{` formas de dar estilo a nuestros proyectos usando
CSS, ya sea por medio de plugins oficiales o hechos por la comunidad.`}</p>
    <p>{`Veamos algunas de las más comunes:`}</p>
    <h3>{`Usando estilos globales en el componente layout`}</h3>
    <p>{`Esta forma es la que nos viene por defecto si creamos nuestro proyecto con el
comando `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`gatsby new`}</code>{`, si vemos el archivo `}<strong parentName="p">{`/src/components/layout.js`}</strong>{`, ahí se
importa con la siguiente línea:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./layout.css'`}</span></code></pre></div>
    <p>{`Así que todo componente o página que esté wrappeada en nuestro componente
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`<Layout>`}</code>{` va a poder hacer uso de las bondades de este archivo de estilos.`}</p>
    <p>{`Caso de que no hayamos utilizado `}<strong parentName="p">{`gatsby new`}</strong>{`, debemos crear un componente
layout donde importemos nuestro archivo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`CSS`}</code>{` y wrappear nuestros componentes de
página con este layout creado.`}</p>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/global-css/"
        }}>{`Estilizando con archivos CSS globales`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/tutorial/part-three"
        }}>{`Más acerca de componentes layout`}</a></li>
    </ul>
    <hr></hr>
    <h3>{`Usando estilos globales sin utilizar un componente layout`}</h3>
    <p>{`Utilizando esta forma vamos a realmente tener nuestros estilos de forma
`}<em parentName="p">{`global`}</em>{`. Lo que tenemos que hacer es (si no tenemos uno ya) crear nuestro
archivo de estilos e importarlo en el archivo `}<strong parentName="p">{`gatsby-browser.js`}</strong>{` de la
siguiente manera:`}</p>
    <p>{`Suponiendo que creamos `}<strong parentName="p">{`src/styles/global.css`}</strong>{`, en gatsby-browser.js:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./src/styles/global.css'`}</span></code></pre></div>
    <p>{`Y vamos a tener disponible en todos nuestros componentes los estilos de ese
archivo.`}</p>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/global-css/#adding-global-styles-without-a-layout-component"
        }}>{`Agregando estilos globales sin componente layout`}</a></li>
    </ul>
    <hr></hr>
    <h3>{`Usando Styled Components`}</h3>
    <p>{`Para utilizar Styled Components con Gatsby, vamos a tener que instalar un
plugin, porque OBVIO que hay uno 😜`}</p>
    <p>{`El plugin nos pide que instalemos lo siguiente:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i gatsby-plugin-styled-components styled-components babel-plugin-styled-components`}</code></pre></div>
    <p>{`Y una vez que tengamos ese plugin instalado, debemos sumarlo en nuestro array de
plugins de nuestro archivo de configuración `}<strong parentName="p">{`gatsby-config.js`}</strong>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`module`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`exports `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-plugin-styled-components`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Luego volvemos bajamos y volvemos a correr nuestro servidor local con `}<strong parentName="p">{`gatsby
develop`}</strong>{` y podemos utilizarlo como se usa con React comúnmente:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` styled `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'styled-components'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` Container `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` styled`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`div`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
  margin: 3rem auto;
  max-width: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` Title `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` styled`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`h1`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
  font-weight: bolder;
  font-size: xx-large;
  color: LightGreen;
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Container`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Title`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`Bienvenidos a mi página`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`Title`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`Container`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-styled-components/"
        }}>{`gatsby-plugin-styled-components`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/styled-components/"
        }}>{`Documentación explicando uso de Styled Components`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://egghead.io/lessons/gatsby-style-gatsby-sites-with-styled-components"
        }}>{`Lección de egghead.io`}</a></li>
    </ul>
    <hr></hr>
    <h3>{`Usando CSS Modules`}</h3>
    <p>{`Para aprovechar las bondades de CSS Modules la forma de utilizarlos sería así:`}</p>
    <p>{`Creamos un módulo CSS `}<strong parentName="p">{`src/pages/index.module.css`}</strong>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "css"
    }}><pre parentName="div" {...{
        "className": "language-css"
      }}><code parentName="pre" {...{
          "className": "language-css"
        }}><span parentName="code" {...{
            "className": "token selector"
          }}>{`.principal`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`font-weight`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` bolder`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`font-size`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` xx-large`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`color`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` LightGreen`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Y luego podemos usarlo importándolo por ejemplo en `}<strong parentName="p">{`src/pagesindes.js`}</strong>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` style `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./index.module.css'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`h1 className`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`style`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`principal`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`Bienvenidos a mi página`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`h1`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/tutorial/part-two/#css-modules"
        }}>{`Utilizando CSS Modules`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/gatsbyjs/gatsby/blob/master/examples/using-css-modules"
        }}>{`Ejemplo de utilización de CSS Modules`}</a></li>
    </ul>
    <hr></hr>
    <h3>{`Usando Sass/SCSS`}</h3>
    <p>{`Para utilizar Sass, necesitamos instalar un plugin:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i node-sass gatsby-plugin-sass`}</code></pre></div>
    <p>{`Lo agregamos a nuestro array de plugins utilizados en configuración, en
`}<strong parentName="p">{`gatsby-config.js`}</strong>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`module`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`exports `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-plugin-sass`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Luego escribimos nuestra hoja de estilos como `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.sass`}</code>{` o `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.scss`}</code>{` y los importamos
donde lo vayamos a utilizar.`}</p>
    <p>{`Ejemplo Sass:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "sass"
    }}><pre parentName="div" {...{
        "className": "language-sass"
      }}><code parentName="pre" {...{
          "className": "language-sass"
        }}><span parentName="code" {...{
            "className": "token variable-line"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$font-stack`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`:`}</span>{` Helvetica, sans-serif`}</span>{`
`}<span parentName="code" {...{
            "className": "token variable-line"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$primary-color`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`:`}</span>{` #333`}</span>{`
`}<span parentName="code" {...{
            "className": "token selector"
          }}>{`body`}</span>{`
`}<span parentName="code" {...{
            "className": "token property-line"
          }}>{`  `}<span parentName="span" {...{
              "className": "token property"
            }}>{`font`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`:`}</span>{` 100`}<span parentName="span" {...{
              "className": "token operator"
            }}>{`%`}</span>{` `}<span parentName="span" {...{
              "className": "token variable"
            }}>{`$font-stack`}</span></span>{`
`}<span parentName="code" {...{
            "className": "token property-line"
          }}>{`  `}<span parentName="span" {...{
              "className": "token property"
            }}>{`color`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`:`}</span>{` `}<span parentName="span" {...{
              "className": "token variable"
            }}>{`$primary-color`}</span></span></code></pre></div>
    <p>{`Ejemplo SCSS:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "scss"
    }}><pre parentName="div" {...{
        "className": "language-scss"
      }}><code parentName="pre" {...{
          "className": "language-scss"
        }}><span parentName="code" {...{
            "className": "token property"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$font-stack`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` Helvetica`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` sans-serif`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token property"
          }}><span parentName="span" {...{
              "className": "token variable"
            }}>{`$primary-color`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` #333`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token selector"
          }}>{`body `}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`font`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` 100% `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$font-stack`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`color`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`$primary-color`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Y los importamos usando la ruta relativa a cada archivo:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./styles.sass'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./styles.scss'`}</span></code></pre></div>
    <p><em parentName="p">{`Nota: Se pueden usar los archivos Sass/SCSS como módulos tal como se explica en
'Usando CSS Modules', con la salvedad de las extensiones de los archivos.`}</em></p>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-sass/"
        }}>{`gatsby-plugin-sass`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://responsivedesign.is/articles/difference-between-sass-and-scss/"
        }}>{`Diferencia entre .sass y .scss`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://sass-lang.com/guide"
        }}>{`Guía de Sass`}</a></li>
    </ul>
    <hr></hr>
    <h3>{`Usando Emotion`}</h3>
    <p>{`Creo que está de más decir que va a haber que instalar un plugin jaja.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i gatsby-plugin-emotion @emotion/core @emotion/styled`}</code></pre></div>
    <p>{`Lo agregamos en la configuración en `}<strong parentName="p">{`gatsby-config.js`}</strong>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`module`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`exports `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  plugins`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-plugin-emotion`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Y con eso ya estamos habilitados a usar Emotion, ya sea con `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`css`}</code>{` o con
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`styled-components`}</code>{`:`}</p>
    <p>{`Usando css:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` css `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'@emotion/core'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`div`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`p
      css`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        background`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'pink'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
        color`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'blue'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
      Esta página utiliza Emotion`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`p`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`div`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p>{`Usando styled-components:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` styled `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'@emotion/styled'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` Content `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` styled`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`div`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
  text-align: center;
  margin-top: 10px;
  p {
    font-weight: bold;
  }
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Content`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`p`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`Esta página utiliza Emotion`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`p`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`Content`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-emotion/"
        }}>{`gatsby-plugin-emotion`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/emotion/"
        }}>{`Usando Emotion en Gatsby`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://egghead.io/lessons/gatsby-getting-started-with-emotion-and-gatsby"
        }}>{`Lección de egghead.io`}</a></li>
    </ul>
    <hr></hr>
    <h2>{`Trabajando con fuentes`}</h2>
    <h3>{`Añadiendo una fuente local`}</h3>
    <p>{`Copiemos nuestra fuente `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.woff2`}</code>{`, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.ttf`}</code>{`, por ejemplo, en la carpeta
`}<strong parentName="p">{`src/fonts/`}</strong>{`. Luego debemos importarla en nuestro CSS:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "css"
    }}><pre parentName="div" {...{
        "className": "language-css"
      }}><code parentName="pre" {...{
          "className": "language-css"
        }}><span parentName="code" {...{
            "className": "token atrule"
          }}><span parentName="span" {...{
              "className": "token rule"
            }}>{`@font-face`}</span></span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`font-family`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Font Name"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`src`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token url"
          }}><span parentName="span" {...{
              "className": "token function"
            }}>{`url`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`(`}</span><span parentName="span" {...{
              "className": "token string url"
            }}>{`"../fonts/fontname.woff2"`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`)`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Y tenemos que asegurarnos de referenciar bien el nombre de la fuente, por
ejemplo:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "css"
    }}><pre parentName="div" {...{
        "className": "language-css"
      }}><code parentName="pre" {...{
          "className": "language-css"
        }}><span parentName="code" {...{
            "className": "token selector"
          }}>{`body`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`font-family`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Font Name"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` sans-serif`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`De esta forma, modificando a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`body`}</code>{`, afectamos a la mayoría del texto en la
página.`}</p>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.org/docs/importing-assets-into-files/"
        }}>{`Importando assets en archivos`}</a></li>
    </ul>
    <hr></hr>
    <h3>{`Usando Google Fonts`}</h3>
    <p>{`Para usar Google Fonts es mejor hostearlas en nuestro proyecto, así mejoramos la
performance al no tener que estar yendo a buscar la fuente a una URL externa.`}</p>
    <p>{`Para utilizar esto debemos seleccionar una fuente del
`}<a parentName="p" {...{
        "href": "https://github.com/KyleAMathews/typefaces"
      }}>{`proyecto typefaces`}</a>{`.`}</p>
    <p>{`Para empezar tenemos que instalar la fuente elegida de la siguiente manera:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i typeface-nombre-de-fuente`}</code></pre></div>
    <p>{`Donde tenemos que reemplazar `}<strong parentName="p">{`nombre-de-fuente`}</strong>{` por la que querramos utilizar,
un ejemplo sería la 'Source Sans Pro', que quedaría así:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i typeface-source-sans-pro`}</code></pre></div>
    <p>{`Luego importamos "typeface-nombre-de-fuente" en un layout, componente de página
o en `}<strong parentName="p">{`gatsby-browser.js`}</strong>{` dependiendo cómo lo querramos utilizar:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'typeface-nombre-de-fuente'`}</span></code></pre></div>
    <p>{`Y una vez importada, ya podemos referenciarla en una hoja de estilos CSS, un CSS
Module o utilizando CSS-in-JS:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "css"
    }}><pre parentName="div" {...{
        "className": "language-css"
      }}><code parentName="pre" {...{
          "className": "language-css"
        }}><span parentName="code" {...{
            "className": "token selector"
          }}>{`body`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token property"
          }}>{`font-family`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"Nombre de fuente"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <h5>{`Para seguir leyendo`}</h5>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.gatsbyjs.com/docs/using-typography-js/"
        }}>{`Typography.js - Otra forma de usar Google Fonts`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/KyleAMathews/typefaces/blob/master/README.md"
        }}>{`Documentación del proyecto Typefaces`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.bricolage.io/typefaces-easiest-way-to-self-host-fonts/"
        }}>{`Ejemplo de uso`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      